
export const getTopLevelDomainFromUrl = (url) => {
  const hostNameParts = new URL(url).hostname.split('.');
  const partCount = hostNameParts.length;

  if (partCount >= 2) {
    const ccTldSpecified = partCount >= 3 && (hostNameParts[partCount - 2].length === 3 || hostNameParts[partCount - 2].length === 2) && hostNameParts[partCount - 1].length === 2;
    return ccTldSpecified ?
      `${hostNameParts[partCount - 3]}.${hostNameParts[partCount - 2]}.${hostNameParts[partCount - 1]}` :
      `${hostNameParts[partCount - 2]}.${hostNameParts[partCount - 1]}`;
  }

  return null;
};

export const isFinalUrlAlignedWithStoreDomain = (finalUrl, storeDomain) => {
  const finalUrlDomain = getTopLevelDomainFromUrl(finalUrl);
  return finalUrlDomain && storeDomain && finalUrlDomain.toLowerCase() === storeDomain.toLowerCase();
};

